$(document).ready(function () {
  marquee();
  function marquee() {
    const marqueeElementsDt = document.querySelectorAll("[data-marquee-dt]");
    if (marqueeElementsDt.length !== 0) {
      marqueeElementsDt.forEach((el) => animateMarquee(el, 10000));
    }
  }

  function animateMarquee(el, duration) {
    const innerEl = el.querySelector(".marquee__inner");
    const innerWidth = innerEl.offsetWidth;
    const cloneEl = innerEl.cloneNode(true);
    el.appendChild(cloneEl);
    let start = performance.now();
    let progress;
    let translateX;
    requestAnimationFrame(function step(now) {
      progress = (now - start) / duration;
      if (progress > 1) {
        progress %= 1;
        start = now;
      }
      translateX = innerWidth * progress;
      innerEl.style.transform = `translate3d(-${translateX}px, 0 , 0)`;
      cloneEl.style.transform = `translate3d(-${translateX}px, 0 , 0)`;
      requestAnimationFrame(step);
    });
  }

  const scrollUpButton = document.querySelector(".scroll-up");

  window.onscroll = function () {
    if (window.scrollY > 500) {
      scrollUpButton.classList.add("visible");
    } else {
      scrollUpButton.classList.remove("visible");
    }
  };

  scrollUpButton.onclick = function () {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  $(".wrapper_slider").slick({
    infinite: true,
    dots: true,
    adaptiveHeight: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    appendArrows: $(".slider_nav_desktop"),
    prevArrow:
      '                <div class="slider-prev">\n' +
      '                    <svg width="20" height="31" viewBox="0 0 20 31" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
      '                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.57381 15.2617L19.5242 4.29377L15.2373 0L0 15.2617L15.7131 31L20 26.7062L8.57381 15.2617Z" fill="white"/>\n' +
      "                    </svg>\n" +
      "                </div>",
    nextArrow:
      '                <div class="slider-next">\n' +
      '                    <svg width="20" height="31" viewBox="0 0 20 31" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
      '                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.4262 15.2617L0.475765 4.29377L4.76267 0L20 15.2617L4.28691 31L0 26.7062L11.4262 15.2617Z" fill="white"/>\n' +
      "                    </svg>\n" +
      "                </div>",

    appendDots: $(".news__dots_desktop"),
    customPaging: function (slider, i) {
      let thumb = $(slider.$slides[i]).data();

      return (
        '<div class="slider_dot"><svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path d="M25.6066 26.6805C28.4196 23.9148 30 20.1637 30 16.2524H18.782C18.782 17.2386 18.3836 18.1844 17.6743 18.8817C16.965 19.579 16.0031 19.9708 15 19.9708C13.9969 19.9708 13.035 19.579 12.3257 18.8817C11.6164 18.1844 11.218 17.2386 11.218 16.2524L0 16.2524C0 20.1637 1.58035 23.9148 4.3934 26.6805C7.20645 29.4462 11.0218 31 15 31C18.9783 31 22.7936 29.4462 25.6066 26.6805Z" fill="white"/>\n' +
        '<path d="M4.3934 4.31947C1.58035 7.08517 3.93991e-07 10.8363 4.97146e-08 14.7476L11.218 14.7476C11.218 13.7614 11.6164 12.8156 12.3257 12.1183C13.035 11.421 13.9969 11.0292 15 11.0292C16.0031 11.0292 16.965 11.421 17.6743 12.1183C18.3836 12.8156 18.782 13.7614 18.782 14.7476H30C30 10.8363 28.4196 7.08517 25.6066 4.31946C22.7936 1.55376 18.9782 3.45426e-07 15 0C11.0218 -3.45426e-07 7.20644 1.55376 4.3934 4.31947Z" fill="white"/>\n' +
        "</svg>\n</div>"
      );
    },
    dotsClass: "news__dots-list",
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 770,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          appendArrows: $(".slider_nav_mobile"),
          appendDots: $(".news__dots_mobile"),
        },
      },
    ],
  });

  if ($(window).width() < 576) {
    $(".wrapper_slider_projects").slick({
      infinite: true,
      dots: true,
      adaptiveHeight: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      appendArrows: $(".slider_projects_mob"),
      prevArrow:
        '          <div class="slider-projects-prev">\n' +
        '                    <svg width="20" height="31" viewBox="0 0 20 31" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.57381 15.2617L19.5242 4.29377L15.2373 0L0 15.2617L15.7131 31L20 26.7062L8.57381 15.2617Z" fill="#AE7EEB"/>\n' +
        "                    </svg>\n" +
        "                </div>",
      nextArrow:
        '          <div class="slider-projects-next">\n' +
        '                    <svg width="20" height="31" viewBox="0 0 20 31" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.4262 15.2617L0.475765 4.29377L4.76267 0L20 15.2617L4.28691 31L0 26.7062L11.4262 15.2617Z" fill="#AE7EEB"/>\n' +
        "                    </svg>\n" +
        "                </div>",

      appendDots: $(".projects__dots_mobile"),
      customPaging: function (slider, i) {
        let thumb = $(slider.$slides[i]).data();

        return (
          '<div class="slider_projects_dot"><svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
          '<path d="M25.6066 26.6805C28.4196 23.9148 30 20.1637 30 16.2524H18.782C18.782 17.2386 18.3836 18.1844 17.6743 18.8817C16.965 19.579 16.0031 19.9708 15 19.9708C13.9969 19.9708 13.035 19.579 12.3257 18.8817C11.6164 18.1844 11.218 17.2386 11.218 16.2524L0 16.2524C0 20.1637 1.58035 23.9148 4.3934 26.6805C7.20645 29.4462 11.0218 31 15 31C18.9783 31 22.7936 29.4462 25.6066 26.6805Z" fill="#AE7EEB"/>\n' +
          '<path d="M4.3934 4.31947C1.58035 7.08517 3.93991e-07 10.8363 4.97146e-08 14.7476L11.218 14.7476C11.218 13.7614 11.6164 12.8156 12.3257 12.1183C13.035 11.421 13.9969 11.0292 15 11.0292C16.0031 11.0292 16.965 11.421 17.6743 12.1183C18.3836 12.8156 18.782 13.7614 18.782 14.7476H30C30 10.8363 28.4196 7.08517 25.6066 4.31946C22.7936 1.55376 18.9782 3.45426e-07 15 0C11.0218 -3.45426e-07 7.20644 1.55376 4.3934 4.31947Z" fill="#AE7EEB"/>\n' +
          "</svg>\n</div>"
        );
      },
      dotsClass: "news__dots-list",
    });
  }

  function tabsHandler() {
    const tabButtons = document.querySelectorAll(".tab_button");
    const tabPanels = document.querySelectorAll(".tab_panel");

    if (!tabButtons.length || !tabPanels.length) {
      return;
    }

    function showTab(tabIndex) {
      tabButtons.forEach((button) => {
        button.classList.remove("active");
      });
      tabPanels.forEach((panel) => {
        panel.style.display = "none";
      });

      tabButtons[tabIndex].classList.add("active");
      tabPanels[tabIndex].style.display = "block";
    }

    tabButtons.forEach((button, index) => {
      button.addEventListener("click", () => {
        showTab(index);
      });
    });

    // Show first tab by default
    showTab(0);
  }

  tabsHandler();

  if ($(window).width() < 800) {
    $(".slick-track").on("click", ".wrapper-slider-item", function () {
      if ($(this).find(".slider_item").hasClass("hover")) {
        // $(this).find(".slider_item_bottom").css('margin-top', '0')
        $(this).find("p").css("opacity", "0").slideUp(300);
        $(this).find(".slider_item").removeClass("hover");
      } else {
        $(this).find(".slider_item").addClass("hover");
        let paragraph = $(this).find("p");
        let height = paragraph.outerHeight(true);
        // $(this).find(".slider_item_bottom").css('margin-top', -height+15 + 'px')
        $(this).find("p").css("opacity", "1").slideDown(300);
      }
    });
  }
  if ($(window).width() >= 800) {
    $(".slider_item").hover(
      function () {
        // При наведении курсора
        $(this).addClass("hover");
        $(this).find(".wrapper_text").addClass("active");
        let paragraph = $(this).find("p");
        let height = paragraph.outerHeight(true);
        // $(this).find(".slider_item_bottom").css('margin-top', -height+15 + 'px')
        $(this).find("p").css("opacity", "1").slideDown(300);
      },
      function () {
        // При уходе курсора
        $(this).find(".wrapper_text").removeClass("active");
        // $(this).find(".slider_item_bottom").css('margin-top', '0');
        $(this).find("p").css("opacity", "0").slideUp(300);
        $(this).removeClass("hover");
      }
    );
  }

  //form

  let phoneFieldValid = document.querySelector(".tel_input");
  if (phoneFieldValid) {
    phoneFieldValid.addEventListener("keypress", (e) => {
      if (!/\d/.test(e.key)) {
        e.preventDefault();
      }
    });
  }

  $(".tel_input").on("focus", function () {
    let mask = $(".tel_input")
      .closest(".wpcf7-form-control-wrap")
      .find(".iti__selected-dial-code")
      .text();
    if (!$(".tel_input").val().includes(mask)) {
      $(".tel_input").val(mask);
    }
  });

  $(".close-popup").click((e) => {
    $(".popup").hide(300);
  });

  let form = $(".wpcf7-form");
  form.submit(function (event) {
    let textField = $(".text_input");
    let phoneField = $(".tel_input");
    let emailField = $(".email_input");

    if (textField.length > 0) {
      if (textField.val().length < 1) {
        event.preventDefault();
        textField.prop("required", true);
        textField.closest(".form_left .input").addClass("error");
        textField.closest(".wpcf7-form-control-wrap").addClass("error");
      } else {
        // $('.error_message_text').remove();
        textField.closest(".form_left .input").removeClass("error");
        textField.closest(".wpcf7-form-control-wrap").removeClass("error");
        textField.prop("required", false);
      }
    }

    if (phoneField.val().length < 6) {
      event.preventDefault();
      phoneField.prop("required", true);
      phoneField.closest(".form_left .input").addClass("error");
      phoneField.closest(".wpcf7-form-control-wrap").addClass("error");
    } else {
      // $('.error_message_phone').remove();
      phoneField.closest(".form_left .input").removeClass("error");
      phoneField.closest(".wpcf7-form-control-wrap").removeClass("error");

      phoneField.prop("required", false);
    }

    if (emailField.length > 0) {
      let email = emailField.val();
      let emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
      if (!emailRegex.test(email)) {
        event.preventDefault();
        emailField.prop("required", true);
        emailField.closest(".form_left .input").addClass("error");
        emailField.closest(".wpcf7-form-control-wrap").addClass("error");
      } else {
        // $('.error_message_email').remove();
        emailField.closest(".form_left .input").removeClass("error");
        emailField.closest(".wpcf7-form-control-wrap").removeClass("error");
        emailField.prop("required", false);
      }
    }

    let wpcf7Elm = document.querySelector(".wpcf7");

    wpcf7Elm.addEventListener(
      "wpcf7mailsent",
      function (event) {
        $(".popup").show(200);
        $(".wpcf7-response-output").hide();
      },
      false
    );
  });

  function telephoneMask() {
    const telephoneInputs = document.querySelectorAll(".tel_input");
    if (telephoneInputs.length !== 0) {
      telephoneInputs.forEach((telephoneInput) => {
        window.intlTelInput(telephoneInput, {
          initialCountry: "auto",
          separateDialCode: false,
          geoIpLookup: (callback) => {
            fetch("https://ipapi.co/json")
              .then((res) => res.json())
              .then((data) => callback(data.country_code))
              .catch(() => callback("us"));
          },
          utilsScript:
            "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js",
        });
      });
    }
  }
  telephoneMask();

  // mobile menu

  const navToggler = document.querySelector(".nav-toggler");
  const navMenu = document.querySelector(".main-navigation");
  const header = document.querySelector(".header_inner");

  // load all event listners
  allEventListners();

  // functions of all event listners
  function allEventListners() {
    // toggler icon click event
    navToggler.addEventListener("click", togglerClick);
    // nav links click event
    //navLinks.forEach((elem) => elem.addEventListener("click", navLinkClick));
  }

  // togglerClick function
  function togglerClick() {
    navToggler.classList.toggle("toggler-open");
    navMenu.classList.toggle("open");
    header.classList.toggle("open");
    document.body.classList.toggle("scroll-lock");
  }

  (function subMenuHandler() {
    if (!window.matchMedia("(max-width: 1100px)").matches) {
      return;
    }

    const menusWithChildren = document.querySelectorAll(
      ".menu .menu-item-has-children"
    );
    if (!menusWithChildren.length) {
      return;
    }

    menusWithChildren.forEach((menuItem) =>
      menuItem.addEventListener("click", (event) => {
        event.preventDefault();
        menuItem.classList.toggle("sub-menu-is-open");
      })
    );
  })();

  function truncateText(reviewText) {
    let fullText = reviewText.attr("data-full-text");
    let symbolsCount;

    if ($(window).width() < 576) {
      symbolsCount = parseInt(reviewText.attr("data-symbols-mob"));
    } else {
      symbolsCount = parseInt(reviewText.attr("data-symbols-dt"));
    }

    // Check if symbolsCount is a valid number
    if (isNaN(symbolsCount) || symbolsCount <= 0) {
      // Fallback to default values if data-symbols-* is not set or invalid
      symbolsCount = $(window).width() < 576 ? 67 : 180;
    }
    let trimmedText = fullText.substr(0, symbolsCount);
    trimmedText = trimmedText.substr(
      0,
      Math.min(trimmedText.length, trimmedText.lastIndexOf(" "))
    );
    reviewText.html(trimmedText + "...");
  }

  function truncateTextServices(reviewText) {
    if (!reviewText.attr("data-full-text")) {
      return;
    }
    let fullText = reviewText.attr("data-full-text");
    let maxLength = 80;
    if ($(window).width() > 990 && fullText.length > maxLength) {
      let trimmedText = fullText.substr(0, maxLength);

      trimmedText = trimmedText.substr(
        0,
        Math.min(trimmedText.length, trimmedText.lastIndexOf(" "))
      );
      reviewText.html(trimmedText + "...");
    }
  }

  if ($(window).width() > 990) {
    $(".text-inner p:first-of-type").each(function () {
      truncateTextServices($(this));
    });

    $(".services-item").on("mouseenter", function () {
      let isActive = $(this).hasClass("active");
      $(".services-item").removeClass("active");
      if (!isActive) {
        $(this).addClass("active");
      }

      $(".text-inner p:first-of-type").each(function () {
        truncateTextServices($(this));
      });

      if ($(this).hasClass("active")) {
        let reviewText = $(this).find(".text-inner p:first-of-type");
        let fullText = reviewText.attr("data-full-text");
        reviewText.html(fullText);
      }
    });

    $(".services-item").on("mouseleave", function () {
      $(".services-item").removeClass("active");
      $(".text-inner p:first-of-type").each(function () {
        truncateTextServices($(this));
      });
    });
  }

  $(".faq-answer__content").each(function () {
    truncateTextWithHTML($(this));
  });

  $(".faq-item").click(function () {
    $(this).toggleClass("active");

    if ($(this).hasClass("active")) {
      let reviewText = $(this).find(".faq-answer__content");
      let fullText = reviewText.attr("data-full-text");
      reviewText.html(fullText);
    } else {
      let reviewText = $(this).find(".faq-answer__content");
      truncateTextWithHTML(reviewText);
    }
  });

  function truncateTextWithHTML(reviewText) {
    let fullHtml = reviewText.html(); // Отримуємо повний HTML-вміст
    let tempDiv = $("<div>").html(fullHtml); // Створюємо тимчасовий контейнер
    let symbolsCount;

    // Визначаємо кількість символів для мобільної та десктопної версії
    if ($(window).width() < 576) {
      symbolsCount = parseInt(reviewText.attr("data-symbols-mob"));
    } else {
      symbolsCount = parseInt(reviewText.attr("data-symbols-dt"));
    }

    // Перевіряємо, чи значення валідне
    if (isNaN(symbolsCount) || symbolsCount <= 0) {
      symbolsCount = $(window).width() < 576 ? 67 : 180;
    }

    let currentLength = 0;
    let truncatedHtml = "";

    function traverseNodes(node) {
      if (currentLength >= symbolsCount) return ""; // Зупиняємося, якщо ліміт досягнуто

      if (node.nodeType === Node.TEXT_NODE) {
        let text = node.nodeValue.trim();
        if (!text) return "";

        let remainingChars = symbolsCount - currentLength;

        if (text.length > remainingChars) {
          let trimmedText = text.substr(0, remainingChars);
          let lastSpace = trimmedText.lastIndexOf(" ");
          if (lastSpace > 0) {
            trimmedText = trimmedText.substr(0, lastSpace); // Уникаємо обрізання слова
          }
          currentLength += trimmedText.length;
          return trimmedText + "..."; // Додаємо "..."
        } else {
          currentLength += text.length;
          return text;
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        let tagName = node.tagName.toLowerCase();
        let innerHtml = "";

        for (let child of node.childNodes) {
          innerHtml += traverseNodes(child);
          if (currentLength >= symbolsCount) break; // Зупиняємося, якщо ліміт досягнуто
        }

        return `<${tagName}>${innerHtml}</${tagName}>`;
      }
      return "";
    }

    for (let child of tempDiv[0].childNodes) {
      truncatedHtml += traverseNodes(child);
      if (currentLength >= symbolsCount) break;
    }

    reviewText.html(truncatedHtml); // Оновлюємо HTML у елементі
  }

  // Удаляем класс ошибки при фокусе на поле
  document
    .querySelectorAll(".wpcf7-form-control-wrap input")
    .forEach(function (input) {
      input.addEventListener("focus", function () {
        this.closest(".wpcf7-form-control-wrap").classList.remove("error");
        this.closest(".input").classList.remove("error");
      });
    });
});

window.addEventListener("load", main);

function toggleMobileCategoriesHandler() {
  const toggler = document.querySelector("[data-mobile-categories-toggler]");
  if (!toggler) {
    return;
  }
  const categoriesContainer = toggler
    .closest(".categories-block__body")
    .querySelector(".categories-outer");
  if (!categoriesContainer) {
    return;
  }

  toggler.addEventListener("click", () => {
    categoriesContainer.classList.toggle("expanded");
    toggler.classList.toggle("active");
  });
}

function categoryCheckboxesHandler() {
  const categoryList = document.querySelector(".categories-block__list");
  const checkboxes = document.querySelectorAll(".category-checkbox");
  const clearBtn = document.querySelector("[data-clear-action]");
  const applyBtn = document.querySelector("[data-apply-action]");
  const selectedCount = document.querySelector(
    "[data-selected-categories-count]"
  );

  if (checkboxes.length === 0 || !categoryList || !clearBtn || !applyBtn) {
    return;
  }

  categoryList.addEventListener("change", () => {
    let checkboxesUnchecked = true;
    let count = 0;
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        checkboxesUnchecked = false;
        count++;
      }
    });
    if (!checkboxesUnchecked) {
      clearBtn.disabled = false;
      applyBtn.disabled = false;
      selectedCount.innerText = `(${count})`;
    } else {
      clearBtn.disabled = true;
      applyBtn.disabled = true;
      selectedCount.innerText = "";
    }
  });
}

// requestAfterReset to pass initial request or not
function resetFormHandler(requestAfterReset = true) {
  const filterForm = document.getElementById("filter-form");
  const clearBtn = document.querySelector("[data-clear-action]");
  const applyBtn = document.querySelector("[data-apply-action]");
  const selectedCount = document.querySelector(
    "[data-selected-categories-count]"
  );

  if (!filterForm || !clearBtn || !applyBtn) {
    return;
  }

  filterForm.reset();
  clearBtn.disabled = true;
  applyBtn.disabled = true;

  if (selectedCount) {
    selectedCount.innerText = "";
  }

  if (requestAfterReset) {
    handleFilters();
  }
}

function filterCaregoriesInputHandler() {
  const filterInput = document.getElementById("category-search");
  const categoryLabels = document.querySelectorAll("label.category-title");

  if (!filterInput || !categoryLabels.length) {
    return;
  }

  filterInput.addEventListener("input", (event) => {
    let filterValue = event.target.value;

    if (/^\d/.test(filterValue)) {
      return;
    }

    filterValue = filterValue.toLowerCase();
    categoryLabels.forEach((label) => {
      if (label.textContent.toLowerCase().includes(filterValue)) {
        label.closest("li").style.display = "block";
      } else {
        label.closest("li").style.display = "none";
      }
    });
  });
}

let page = 1;
function applyFiltersHandler(page, deleteExising = true) {
  const loadMoreBtn = document.getElementById("load-more");
  const casesCategoryBtn = document.getElementById("cases-category-btn");

  let selectedCategories = [];
  $('input[name="category[]"]:checked').each(function () {
    selectedCategories.push($(this).val());
  });

  let sortOption =
    $('input[name="sort"]:checked').val() ||
    $('input[name="sort-mobile"]:checked').val();
  let searchQuery = $('input[name="search"]').val(); // Получаем значение поля поиска

  let data = {
    category: selectedCategories,
    sort: sortOption,
    search: searchQuery, // Добавляем поисковый запрос
    paged: page,
  };

  $.ajax({
    url: ajaxUrl + "?action=filter_blog",
    type: "GET",
    data: data,
    dataType: "json",
    success: function (response) {
      if (deleteExising) {
        $("#filtered-posts").empty();
      }
      $("#filtered-posts").append(response.posts);
      if (!response.has_more) {
        loadMoreBtn.style.display = "none";
      } else {
        loadMoreBtn.style.display = "inline-block";
      }
      page++;
      if (casesCategoryBtn) {
        casesCategoryBtn.disabled = false;
      }
    },
    error: function (xhr, status, error) {
      console.log("Error: " + error);
    },
  });
}

function handleFilters() {
  // Обновляем фильтры
  page = 1; // Сбрасываем номер страницы при любом изменении фильтра
  const loadMoreBtn = document.getElementById("load-more");
  if (loadMoreBtn) {
    loadMoreBtn.dataset.page = 1;
    loadMoreBtn.style.display = "inline-block";
  }
  applyFiltersHandler(page); // Применяем фильтры
}

function sortHandler() {
  $('input[name="sort"]').on("change keyup", function () {
    let selectedSortOption = $('input[name="sort"]:checked').length;

    if (selectedSortOption > 0) {
      // Снимаем все выбранные опции в category-filter
      $('input[name="category[]"]').prop("checked", false);
    }

    $('input[name="sort-mobile"]').prop("checked", false);

    handleFilters(); // Обрабатываем фильтры
  });

  $('input[name="sort-mobile"]').on("change keyup", function () {
    let selectedSortOption = $('input[name="sort-mobile"]:checked').length;

    if (selectedSortOption > 0) {
      // Снимаем все выбранные опции в category-filter
      $('input[name="category[]"]').prop("checked", false);
    }

    $('input[name="sort"]').prop("checked", false);

    handleFilters(); // Обрабатываем фильтры

    if (window.innerWidth < 768) {
      setTimeout(function () {
        $(".categories-block__wrapper").removeClass("visible");
      }, 300);
    }
  });
}

function searchHandle() {
  $("#search-input").on("keypress", function (e) {
    if (e.key === "Enter") {
      handleFilters();
      e.preventDefault();
    }
  });

  $("#search-btn").on("click", function () {
    const $input = $("#search-input");
    if ($input.val().trim() === "") {
      $input.focus(); // Автоматически фокусируемся на поле ввода
    } else {
      handleFilters();
    }
  });
}

function addEventListenersHandler() {
  const clearBtn = document.querySelector("[data-clear-action]");
  const applyBtn = document.querySelector("[data-apply-action]");
  const loadMoreBtn = document.getElementById("load-more");
  const casesCategoryBtn = document.getElementById("cases-category-btn");

  if (clearBtn) {
    clearBtn.addEventListener("click", resetFormHandler);
  }

  if (applyBtn) {
    applyBtn.addEventListener("click", () => {
      applyFiltersHandler(page);
      setTimeout(() => {
        document
          .querySelector(".categories-block__wrapper")
          .classList.remove("visible");
        document.body.classList.remove("scroll-lock");
      }, 500);
    });
  }

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener("click", (event) => {
      applyFiltersHandler(++event.target.dataset.page, false);
    });
  }

  if (casesCategoryBtn) {
    casesCategoryBtn.addEventListener("click", () => {
      const casesCategoryId = +casesCategoryBtn.dataset.casesCategoryId;

      if (casesCategoryBtn === 0) {
        return;
      }

      resetFormHandler(false);

      const casesCategoryCheckbox = document.getElementById(
        `catid_${casesCategoryId}`
      );

      if (casesCategoryCheckbox) {
        casesCategoryCheckbox.checked = !casesCategoryCheckbox.checked;
        casesCategoryCheckbox.dispatchEvent(
          new Event("change", { bubbles: true })
        );
      }

      if (applyBtn) {
        applyBtn.click();
      }

      casesCategoryBtn.disabled = true;
    });
  }
}

function toggleCategoriesBlockHandler() {
  const categoriesBtnOpen = document.querySelector("[data-categories-open]");
  const categoriesWrapper = document.querySelector(
    ".categories-block__wrapper"
  );
  const filterToggleMobile = document.querySelector(
    "[data-mobile-filter-toggle]"
  );

  if (!categoriesBtnOpen || !categoriesWrapper) {
    return;
  }

  const categoriesBtnClose = categoriesWrapper.querySelector(
    "[data-categories-close]"
  );
  if (!categoriesBtnClose) {
    return;
  }

  if (filterToggleMobile) {
    filterToggleMobile.addEventListener("click", () => {
      categoriesWrapper.classList.add("visible");
    });
  }

  categoriesBtnOpen.addEventListener("click", () => {
    categoriesWrapper.classList.add("visible");
    categoriesBtnOpen.classList.remove("white");
    categoriesBtnOpen.classList.add("yellow");
    document.body.classList.add("scroll-lock");
  });
  categoriesBtnClose.addEventListener("click", () => {
    categoriesWrapper.classList.remove("visible");
    document.body.classList.remove("scroll-lock");
    categoriesBtnOpen.classList.add("white");
    categoriesBtnOpen.classList.remove("yellow");
  });
}

const authorLoadMoreBtn = document.querySelector("[data-author-load-more]");

if (authorLoadMoreBtn) {
  authorLoadMoreBtn.addEventListener("click", getAuthorsPosts);
}

function getAuthorsPosts(event) {
  const page = +event.target.dataset.page;
  const authorId = +event.target.dataset.authorId;

  let data = {
    authorId: authorId,
    paged: page,
  };

  console.log(data);

  $.ajax({
    url: ajaxUrl + "?action=load_author_posts",
    type: "GET",
    data: data,
    dataType: "json",
    success: function (response) {
      $("#filtered-posts").append(response.posts);
      if (!response.has_more) {
        event.target.style.display = "none";
      } else {
        event.target.style.display = "inline-block";
      }
      event.target.dataset.page++;
    },
    error: function (xhr, status, error) {
      console.log("Error: " + error);
    },
  });
}

function filtersHandler() {
  addEventListenersHandler();
  toggleMobileCategoriesHandler();
  categoryCheckboxesHandler();
  filterCaregoriesInputHandler();
  sortHandler();
  searchHandle();
  toggleCategoriesBlockHandler();
}

function showLeadFormHandler() {
  const showBtn = document.querySelector("[data-show-lead-form]");
  const popup = document.getElementById("lead-form-popup");

  if (!showBtn || !popup) {
    return;
  }

  showBtn.addEventListener("click", () => {
    document.body.classList.add("scroll-lock");
    popup.classList.add("popup-visible");
  });
}

function closePopupHandler() {
  const closeBtns = document.querySelectorAll(".btn-close-popup");

  if (!closeBtns.length) {
    return;
  }

  closeBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const popup = btn.closest(".popup-wrapper");
      if (!popup) {
        return;
      }
      document.body.classList.remove("scroll-lock");
      popup.classList.remove("popup-visible");
    });
  });
}

function leadFormSubmitHandler() {
  const form = document.querySelector("#lead-form-popup .wpcf7");
  const popup = document.getElementById("thankyou-popup");
  if (!form || !popup) {
    return;
  }

  form.addEventListener("wpcf7mailsent", () => {
    const currentFormPopup = form.closest(".popup-wrapper");
    if (currentFormPopup) {
      currentFormPopup.classList.remove("popup-visible");
    }
    popup.classList.add("popup-visible");
    document.body.classList.add("scroll-lock");
  });
}

function subscribeFormSubmitHandler() {
  const forms = document.querySelectorAll("[data-subscribe-form] .wpcf7");
  const popup = document.getElementById("subscribe-thankyou-popup");
  if (!forms.length || !popup) {
    return;
  }

  forms.forEach((form) => {
    form.addEventListener("wpcf7mailsent", () => {
      popup.classList.add("popup-visible");
      document.body.classList.add("scroll-lock");
    });
  });
}

function categoryTopSlider() {
  const slider = document.querySelector("[data-category-top-posts]");
  const isTargetScreenSize = window.matchMedia("(max-width: 768px)").matches;

  if (!slider || !isTargetScreenSize) {
    return;
  }

  const options = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    infinite: true,
  };

  $(slider).slick(options);
}

function postGallerySliders() {
  const sliders = document.querySelectorAll("[data-single-post-gallery]");

  if (!sliders.length) {
    return;
  }

  const options = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    infinite: true,
    adaptiveHeight: true,
    fade: true,
    cssEase: "linear",
  };

  sliders.forEach((slider) => {
    $(slider).slick(options);
    $(slider).slick("setPosition");
  });
}

function categoryLoadMore() {
  let page = 2;
  const loadMoreButton = document.getElementById("category-load-more");
  const postContainer = document.getElementById("post-container");

  if (!loadMoreButton || !postContainer) {
    return;
  }

  const categoryID = loadMoreButton.dataset.category;

  loadMoreButton.addEventListener("click", (event) => {
    event.preventDefault();

    $.ajax({
      url: ajaxUrl,
      type: "GET",
      data: {
        action: "load_more_posts",
        page: page,
        category: categoryID,
      },
      success: function (data) {
        if (data) {
          postContainer.insertAdjacentHTML("beforeend", data);
          loadMoreButton.dataset.currentPage = page;

          const baseUrl = window.location.pathname.split("/page/")[0];
          const newUrl =
            baseUrl + (baseUrl.endsWith("/") ? "" : "/") + "page/" + page + "/";
          window.history.pushState({ page: page }, "", newUrl);
          page++;

          if (
            +loadMoreButton.dataset.currentPage >=
            +loadMoreButton.dataset.maxPage
          ) {
            loadMoreButton.style.display = "none";
          }
        } else {
          console.log("no data");
        }
      },
      error: function () {
        console.log("failed to fetch");
      },
    });
  });
}

/******************************************************************** */

function main() {
  filtersHandler();
  showLeadFormHandler();
  closePopupHandler();
  leadFormSubmitHandler();
  subscribeFormSubmitHandler();
  categoryTopSlider();
  postGallerySliders();
  categoryLoadMore();
}
